<template functional>
  <div>
    <p v-if="!props.row['comparate']" class="pl-2 mt-2">
      {{ props.row[props.column] }}
    </p>
    <p v-else>-</p>
    <template v-if="props.row['comparate']">
      <div style="background-color: rgb(135 203 22 / 13%)">
        <p class="pl-2 py-3 mb-0">
          {{
            props.row[`${props.column}Comparate`]
              ? props.row[`${props.column}Comparate`]
              : props.row[`${props.column}`]
          }}
        </p>
      </div>
    </template>
    <template
      v-else-if="
        !props.row['comparate'] &&
        props.row[`${props.column}Comparate`] !== null &&
        Number(props.row[`${props.column}Comparate`]) >= 0
      "
    >
      <div style="background-color: rgb(135 203 22 / 13%)">
        <p class="pl-2 py-3 mb-0">
          {{
            props.row[`${props.column}Comparate`]
            /* ? props.row[`${props.column}Comparate`]
              : props.row[`${props.column}`] */
          }}
        </p>
      </div>
    </template>
    <template
      v-else-if="
        !props.row['comparate'] && props.row[`${props.column}Comparate`]
      "
    >
      <div style="background-color: rgb(135 203 22 / 13%)">
        <p class="pl-2 py-3 mb-0">
          {{ props.row[`${props.column}Comparate`] }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ComparateFormatter',
};
</script>
